require('jquery-serializejson');
import Swal from "sweetalert2";
import ApiService from "@/ts/core/services/ApiService";
import { startSpinner } from "../modules/startSpinner";
var Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: function (toast) {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
});
var recruitApplyCheck = function (recruit_mgmt_code, url, is_outside_korea, does_show_visa_popup) {
    if (is_outside_korea == true) {
        window.modalOpen('residenceAlert');
    }
    else if (does_show_visa_popup == true) {
        window.modalOpen('visaAlert');
    }
    else {
        recruitApply(recruit_mgmt_code, url);
    }
};
var recruitApply = function (recruit_mgmt_code, url) {
    var _a = startSpinner(), spinnerContainer = _a.spinnerContainer, spinner = _a.spinner;
    return ApiService.post("".concat(process.env.MIX_API_HOST, "/recruit/").concat(recruit_mgmt_code, "/apply"), {})
        .then(function (_a) {
        var data = _a.data;
        console.log(data);
        if (url !== null)
            window.open(url, '_blank');
        else {
            Toast.fire({
                text: data.message,
                icon: "success",
            });
        }
    })
        .catch(function (_a) {
        var response = _a.response;
        if ((response === null || response === void 0 ? void 0 : response.status) === 403) {
            window.modalOpen('noResumeAlert');
        }
        else {
            var message = response.data.message;
            Toast.fire({
                text: message,
                icon: "error",
            });
        }
    })
        .finally(function () {
        if (spinnerContainer) {
            spinnerContainer.style.display = 'none';
        }
        spinner.stop();
    });
};
window.recruitApplyCheck = recruitApplyCheck;
window.recruitApply = recruitApply;
